export const Background = () => {
    return (
        <div className="fixed inset-0 -z-10 overflow-hidden">
            {/* Warm dark base */}
            <div className="absolute inset-0 bg-[#0a0608]" />

            {/* Soft rose orbs */}
            <div
                className="absolute -top-20 left-1/2 -translate-x-1/2 w-[520px] h-[520px] rounded-full bg-rose-400/10 blur-[130px]"
            />
            <div
                className="absolute bottom-0 right-[-100px] w-[380px] h-[380px] rounded-full bg-rose-500/10 blur-[110px]"
            />
            <div
                className="absolute top-1/2 left-[-100px] w-[300px] h-[300px] rounded-full bg-pink-300/[0.06] blur-[90px]"
            />

            {/* Vignette */}
            <div
                className="absolute inset-0 pointer-events-none"
                style={{
                    background: 'radial-gradient(ellipse at center, transparent 0%, rgba(10,6,8,0.85) 100%)'
                }}
            />
        </div>
    );
};

export default Background;
